/**
 * @func shortenString
 * @param {string} string to shorten
 * @param {number} charPosition position
 * @returns {string}
 */
export function shortenString (string, charPosition) {
  return string.substring(0, charPosition) + ' ...'
}

/**
 * @func formatPhoneNumber
 * @param {string} phoneNumber the phone number to parse
 * @returns {string}
 */
export function formatPhoneNumber (phoneNumber) {
  const cleaned = ('' + phoneNumber).replace(/\D/g, '')
  const match = cleaned.match(/^(1|)?(\d{3})(\d{3})(\d{4})$/)
  if (match) {
    const intlCode = (match[1] ? '+1 ' : '')
    return [intlCode, '(', match[2], ') ', match[3], '-', match[4]].join('')
  }
  return phoneNumber
}
